<mat-form-field [formGroup]="localFormGroup" [appearance]="appearance">
  <mat-label>{{label | translate}}{{requiredAsterix}}</mat-label>
  <input [id]="'nc-quick-search-input-' + textInputId" matInput [readonly]="isReadonly" [formGroup]="formGroup" *ngIf="isReadonly"
         formControlName="quickSearchFilter">
  <input #textInput
         *ngIf="!isReadonly"
         [id]="'nc-quick-search-input-' + textInputId"
         matInput
         type="search"
         [placeholder]="placeholder | translate"
         formControlName="quickSearchFilter"
         [matAutocomplete]="auto"
         [errorStateMatcher]="stateMatcher"
         (blur)="onBlur($event)"/>
  <button mat-button
          type="button"
          [id]="'nc-quick-search-button-' + resetButtonId"
          *ngIf="!isReadonly && control.value && control.enabled"
          [tabIndex]="-1"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="reset()">
    <mat-icon>close</mat-icon>
  </button>
  <button mat-button
          type="button"
          [id]="'nc-quick-search-button-' + undoButtonId"
          *ngIf="!isReadonly && showUndo$ | async"
          [tabIndex]="-1"
          matSuffix
          mat-icon-button
          (click)="undo()">
    <mat-icon>cached</mat-icon>
  </button>
  <mat-autocomplete [id]="id" #auto="matAutocomplete" (optionSelected)="onSelectOption($event.option.value)">
    <ng-container *ngIf="data$ | async as data">
      <cdk-virtual-scroll-viewport *ngIf="data && data.length else noRecords" itemSize="10" class="autocomplete-test-viewport"
                                   [ngStyle]="{'height': height}">
        <mat-option *cdkVirtualFor="let item of data" [value]="item">
          <ng-container *ngIf="templateRef else noTemplate">
            <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: item}"></ng-template>
          </ng-container>
          <ng-template #noTemplate>{{item.text}}</ng-template>
        </mat-option>
      </cdk-virtual-scroll-viewport>
      <ng-template #noRecords>
        <mat-option *ngIf="showNoResults$ | async" disabled>{{noResultsLabel | translate}}</mat-option>
      </ng-template>
    </ng-container>
  </mat-autocomplete>
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="loading$ | async">
  <mat-progress-bar mode="indeterminate">
  </mat-progress-bar>
</ng-container>
